var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c("mini-header", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                !_vm.$store.state.auth.account.acc_id
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "grey-900",
                          to: { name: "AuthChoose", params: _vm.$route.params },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-arrow-left "),
                        ]),
                        _vm._v("Volver a organizaciones"),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        {
          staticClass: "px-0",
          class: { "mt-16": !_vm.$store.state.auth.account.acc_id },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-bold",
                    },
                    [_vm._v("Cuenta de usuario")]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c(
                    "v-list",
                    { staticClass: "v-list-form-card pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [_vm._v("Nombre")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-col", { attrs: { cols: "6" } }, [
                                _vm.user?.given_name
                                  ? _c("span", { staticClass: "d-block" }, [
                                      _vm._v(_vm._s(_vm.user.given_name)),
                                    ])
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 text--disabled font-italic",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [_vm._v("Apellido")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-col", { attrs: { cols: "6" } }, [
                                _vm.user?.family_name
                                  ? _c("span", { staticClass: "d-block" }, [
                                      _vm._v(_vm._s(_vm.user.family_name)),
                                    ])
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "body-2 text--disabled font-italic",
                                      },
                                      [_vm._v("Sin especificar")]
                                    ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "my-8", attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-bold",
                    },
                    [_vm._v("Seguridad de la cuenta")]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c(
                    "v-list",
                    { staticClass: "v-list-form-medium pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [_vm._v("Contraseña")]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "grey-900" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.modalPatchPassword = true
                                        },
                                      },
                                    },
                                    [_vm._v("Cambiar contraseña")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "500",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalPatchPassword,
            callback: function ($$v) {
              _vm.modalPatchPassword = $$v
            },
            expression: "modalPatchPassword",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v("Cambiar contraseña")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.modalPatchPassword = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c(
                    "v-list",
                    {
                      staticClass:
                        "v-list-form-extended-medium pa-0 transparent",
                    },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Contraseña actual"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-text-field", {
                                staticClass: "icon-field",
                                attrs: {
                                  autocomplete: "off",
                                  error: _vm.$v.password.old_password.$error,
                                  "append-icon": _vm.show
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.show
                                    ? "$v.password.old_password.$model"
                                    : "password",
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "56",
                                  "data-action": "auto-focus",
                                  placeholder: "Escribe tu contraseña actual",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.show = !_vm.show
                                  },
                                },
                                model: {
                                  value: _vm.$v.password.old_password.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.password.old_password,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "$v.password.old_password.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [_vm._v("Nueva contraseña")]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-text-field", {
                                staticClass: "icon-field",
                                attrs: {
                                  autocomplete: "off",
                                  error: _vm.$v.password.new_password1.$error,
                                  "append-icon": _vm.show1
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.show1
                                    ? "user.password1"
                                    : "password",
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "56",
                                  "data-action": "auto-focus",
                                  placeholder:
                                    "Escribe una nueva contraseña segura",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.show1 = !_vm.show1
                                  },
                                },
                                model: {
                                  value: _vm.$v.password.new_password1.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.password.new_password1,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "$v.password.new_password1.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Confirmar contraseña"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "py-1" },
                            [
                              _c("v-text-field", {
                                staticClass: "icon-field",
                                attrs: {
                                  autocomplete: "off",
                                  error: _vm.$v.password.new_password2.$error,
                                  "append-icon": _vm.show2
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  type: _vm.show2
                                    ? "user.password2"
                                    : "password",
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "56",
                                  placeholder:
                                    "Escribe otra vez la nueva contraseña",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.show2 = !_vm.show2
                                  },
                                },
                                model: {
                                  value: _vm.$v.password.new_password2.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.password.new_password2,
                                      "$model",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression:
                                    "$v.password.new_password2.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.modalPatchPassword = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { loading: _vm.patchLoader, color: "grey-900" },
                      on: { click: _vm.patchPassword },
                    },
                    [_vm._v("Cambiar contraseña")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }